// What the masterclass page reads and writes beyond the product's own rows (src/product/data.js),
// as the member themselves (docs/data-model.md 10.2 and 10.3). While staff view as a member none of
// the writes is called (the page checks), and the database and the function would refuse them anyway.
import { supabase, must } from '../../lib/supabase.js'
import { callHubFunction } from '../../lib/functions.js'
import { SENT_COLUMNS } from './model.js'

// The offer and the owner's card for them: hub.my_offer_state, 0 or 1 row
// { offer_hidden, owner_card, offer_on, offer, card }. The page reads the offer and the card from
// here only, never from catalogue.settings.
export async function loadOfferState(productId) {
  const rows = await supabase.rpc('my_offer_state', { p_masterclass: productId }).then(must)
  return rows?.[0] || null
}

// Whether play and offer have been sent to n8n for them, so the page asks only when they haven't
export async function loadSent(personId, productId) {
  const rows = await supabase.from('member_product_state').select(SENT_COLUMNS)
    .eq('person_id', personId).eq('product_id', productId).then(must)
  return rows?.[0] || null
}

// The offer reached, written straight away (not on the 15-second save), so it shows on every device
// they log in on: 'position' (the player passed the minute), 'ended' or 'show_now'. The database
// keeps the first time it was reached and refuses any change after that.
export async function markReached(personId, productId, how) {
  const at = new Date().toISOString()
  must(await supabase.from('member_product_state').upsert(
    { person_id: personId, product_id: productId, offer_reached_at: at, offer_reached_how: how },
    { onConflict: 'person_id,product_id' },
  ))
  return at
}

// The watch page's 2 events for n8n's masterclass-watch, sent from the server once per person
// (masterclass-event): 'play' the first time the video starts, 'offer' once the offer is reached and
// shown. The answer is { ok, event, outcome: 'sent' | 'already' | 'no_checkout', sent_at }; a
// refusal throws, and the page shows none of them.
export function sendEvent(event) {
  return callHubFunction('masterclass-event', { event })
}
